import {Component, EventEmitter, Inject, Input} from '@angular/core';
import {HelpModel} from '@spout/global-web/models';
import {Observable, Subject} from 'rxjs';
import {CONTAINER_DATA, ContentModel} from '../content.model';

@Component({
  selector: 'spt-help-sample-rate',
  templateUrl: './help-sample-rate.component.html',
  styleUrls: ['./help-sample-rate.component.scss']
})
export class HelpSampleRateComponent implements ContentModel {
  static ref = HelpModel.SAMPLE_RATE;
  static title = 'Sample Rate';

  showBackHeader = true;

  helpTitle = HelpSampleRateComponent.title;

  private modalClose: Subject<any> = new Subject();

  onModalClose(): Observable<any> {
    return this.modalClose.asObservable();
  }

  constructor(@Inject(CONTAINER_DATA) private data: ContentModel) {
    if (this.data) {
      this.showBackHeader = this.data.showBackHeader;
    }
  }

  closeModal() {
    this.modalClose.next(null);
    this.modalClose.complete();
  }
}
